import { Category } from '../models/Category';

export class CategoryProxy {
    static formatForUI(category: any, language: string) {
        // Handle variations like 'ar-SA' or 'en-US'
        const shortLang = language.split('-')[0];
        const langData = category[shortLang] || category.en || {};

        return {
            id: category.id,
            name: langData.name || category.en?.name || 'Unknown',
            name_ar: category.ar?.name || '',
            name_en: category.en?.name || '',
            name_tr: category.tr?.name || '',
            slug: category.slug,
        };
    }

    static formatListForUI(categories: Category[], language: string) {
        return categories.map(cat => this.formatForUI(cat, language));
    }
}
